module.exports = __webpack_public_path__ + "img/WC.382e3b5.svg";